<template>
  <!-- 生成凭证 -->
  <div id='AddInvoiceTemplate'>
    <el-dialog :title="form.id?'编辑凭证模板':'生成凭证模板'" :visible.sync="isShow" width="886px" :close-on-click-modal='false'
      :close-on-press-escape="false" class='AddInvoiceTemplateDialog'>
      <div class='dialog_container'>
        <el-row style='margin-bottom:20px; margin-left: 30px;'>
          <el-col :span='8'>
            <span>模板名称：</span>
            <el-input size='small' v-model='form.name' style='width: 180px;' placeholder='请输入名称'></el-input>
          </el-col>
           <el-col :span='8'>
            <span>凭证日期：</span>
            <el-select v-model="form.voucherDateRule" placeholder="请选择" style="width: 180px;" size="small">
              <el-option label="开票日期" :value="1"></el-option>
              <el-option label="当期末" :value="0"></el-option>
            </el-select>
            <!-- <el-input size='small' v-model='form.voucherDateRule' style='width: 180px;' placeholder='请输入名称'></el-input> -->
          </el-col>
          <el-col :span='8' style='text-align: right'>
            <span>凭证字：</span>
            <el-select v-model="form.vocherWordId" style='width: 65px;' size='small'>
              <el-option v-for="item in voucherWordList" :key="item.id" :label="item.certificateWord" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <public-table :table="tableData">
          <template slot='summary' slot-scope='props'>
            <el-dropdown trigger="click" :hide-on-click='false'>
              <span class="el-dropdown-link" style='cursor: pointer;'>
                {{ props.scope.row.summaryText && props.scope.row.summaryText != "_" ? props.scope.row.summaryText : "请设置摘要" }}<i
                  class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style='width: 215px;'>
                <el-dropdown-item style='font-weight: 600;'>固定文本</el-dropdown-item>
                <el-dropdown-item>
                  <el-checkbox v-model='props.scope.row.haveSummary' @change='handleInputBlur(props.scope.row)'><el-input
                      size='small' style='width: calc(100% - 24px);' placeholder='请输入摘要' v-model='props.scope.row.summary'
                      @blur='handleInputBlur(props.scope.row)'></el-input></el-checkbox>

                </el-dropdown-item>
                <el-dropdown-item style='font-weight: 600;margin-top: 20px;margin-bottom: 10px;'>发票信息</el-dropdown-item>
                <el-dropdown-item>
                  <el-checkbox-group v-model="props.scope.row.checkList"
                    @change='handleChangeCheckbox($event, props.scope.row, summaryList)'>
                    <el-checkbox v-for='i in summaryList' :key='i.id' :title='i.description' :label='i.value'
                      style='display: block;'>{{ i.label }}</el-checkbox>
                  </el-checkbox-group>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot='subjactId' slot-scope='props'>
            <el-select v-model="props.scope.row.subjactId" placeholder="请选择" size='mini' filterable popper-class="options"  ref="selectRef">
              <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <template>
                <div class="addKM" @click.stop="newModalOpen(props.scope.row)">+新增科目</div>
              </template>
            </el-select>
          </template>
          <template slot='invoiceValue' slot-scope='props'>
            <el-select v-model="props.scope.row.invoiceValue" placeholder="请选择" size='mini'>
              <el-option v-for="item in invoiceValueList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template slot='invoiceSubjectRule' slot-scope='props'>
            <el-select v-model="props.scope.row.invoiceSubjectRule" placeholder="请选择" size='mini'
              @change='handleCheckTrue($event, invoiceSubjectRuleList, props.scope.row)'>
              <el-option v-for="item in invoiceSubjectRuleList" :key="item.value" :label="item.label"
                :disabled="item.disabled" :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template slot='creditDirection' slot-scope='props'>
            <el-select v-model="props.scope.row.creditDirection" placeholder="请选择" size='mini'>
              <el-option v-for="item in creditDirectionList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
          <template slot='operation' slot-scope='props'>
            <div class='hiddenRow'>
              <span @click='handleOperationTable("+", props.scope.row)'>
                <i class="el-icon-plus" title="新增一条" style="margin-right: 15px;"></i>

              </span>
              <span @click='handleOperationTable("-", props.scope.row)'>
                <i class="el-icon-delete" title="删除当前" style="margin-right: 15px;"></i>
              </span>
            </div>
          </template>
        </public-table>
        <div style='text-align: center;margin-top: 50px;'>
          <el-button size='small' style='width: 122px;background-color: #9B9B9B;color: #fff;'
            @click='isShow = false'>取消</el-button>
          <el-button size='small' style='width: 122px;background-color: #269D7B;color: #fff;'
            @click='handleBtnSave'>保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 科目弹出层-->
    <subject-dialog
      :subParent="false"
      v-if="addSubjectDialog"
      :show="addSubjectDialog"
      :subjectData="formDatas"
      @on-close-modal="cancel"
      @add-success-subject="addSuccessCallback"
    ></subject-dialog>
  </div>
</template>
<script>
import publicTable from '@/components/publicTable'
import subjectDialog from "@/components/dialog/subjectDialog";
export default {
  props: {
    AddInvoiceTemplateDialogShow: Boolean,
    nowRow: Object
  },
  components: {
    publicTable,subjectDialog
  },
  data() {
    return {
      addSubjectRow: {},
      formDatas: {},
      addSubjectDialog: false,
      voucherWordList: [],// 凭证字
      creditDirectionList: ["借", "贷"],  // 余额方向
      subjectList: [],    // 科目列表
      invoiceSubjectRuleList: [],  // 科目规则
      invoiceValueList: [],  // 取值列表
      objectOptions: [],//会计科目列表
      summaryList: [],//摘要下拉列表
      form: {
        voucherDateRule:0,
        name: "",
        vocherWordId: "",
        invoiceVoucherAddendumTemList: [],
        id: "",
      },
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: false,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        config: [{
          label: '',
          value: 'operation',
          show: 'template',
          width: 30,
        }, {
          label: '摘要',
          value: 'summary',
          show: 'template'
        }, {
          label: '会计科目',
          value: 'subjactId',
          show: 'template'
        }, {
          label: '余额方向',
          value: 'creditDirection',
          show: 'template'
        }, {
          label: '取值',
          value: 'invoiceValue',
          show: 'template'
        }, {
          label: '科目规则',
          value: 'invoiceSubjectRule',
          show: 'template',
        }],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          count: 10
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        renderHeader: this.renderHeader,
        cellStyle: this.cellStyle,		// 自定义表格样式
        headerCellStyle: this.headerCellStyle,		// 自定义表头样式
      },

      tableData_c: {
        summary: "",  // 摘要
        subjactId: "",  // 科目ID
        creditDirection: "",  // 借贷方向
        invoiceValue: "",  // 取值
        invoiceSubjectRule: "", // 科目规则
        invoiceInfo: '',  // 发票信息ids
        summaryText: "",
        haveSummary: false,    // 是否勾选摘要
        checkList: [],
        index: 0
      }
    }
  },
  created() {
    this.getSummaryList();
    this.getInvoiceValue();
    this.getInvoiceSubjectRule();
    this.getSubject();
    this.getVoucerWordlList();
  },
  computed: {

    // 显示弹窗
    isShow: {
      get() {
        return this.AddInvoiceTemplateDialogShow;
      },
      set(val) {
        this.$emit('update:AddInvoiceTemplateDialogShow', val);
      }
    },
  },
  methods: {
    newModalOpen(row) {
      let subjectId = row.subjactId
      this.addSubjectRow = row;
      let nowSub = this.subjectList.find(i => i.id === subjectId);
      this.formDatas = {
          methods: "newAdd",
          // type: nowSub?nowSub.type:"资产",
          // creditDirection: "借",
          // code: nowSub?nowSub.code:"",
          // pid: nowSub?nowSub.id:""
          ...nowSub
        }
        this.$refs.selectRef.blur();
        this.addSubjectDialog = true;
    },
    cancel() {
      this.addSubjectDialog = false;
    },
    //新增成功科目后进行新的赋值
    addSuccessCallback(val) {
      this.getSubject(()=> {
        this.addSubjectRow.subjactId = val.id;
      })
    },
    // 新增删除表格
    handleOperationTable(type, row) {
      if (type === "+") {
        let data = JSON.parse(JSON.stringify(this.tableData_c))
        if (row.index === this.tableData.data.length - 1) {
          this.tableData.data.push(data);
        } else {
          this.tableData.data.splice(row.index, 0, data)

        }

      } else {
        if (this.tableData.data.length === 2) {
          return this.$message.warning('表格必须保留两条数据!')
        }
        this.tableData.data.splice(row.index, 1);
      }
      this.tableData.data.map((i, index) => {
        i.index = index;
        return i;
      })
    },
    // 表头单元格样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "headerCellStyles"
      }

    },
    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "cellStyle"
      }
    },
    // 自定义表头
    renderHeader(h, { column }) {
      if (column.property == "invoiceValue") {
        return h("div", [
          h("span", ['取值']),
          h("el-tooltip", {
            attrs: {

              content: "所生产内容取值对象为0时的不会生成对应分录",
              placement: "bottom"
            }
          }, [
            h("i", {
              'class': 'el-icon-warning',
              'style': 'color:#F5A623;margin-left:5px'
            })
          ])
        ])

      } else {
        return column.label
      }
    },
    // 检测科目是否有辅助核算
    handleCheckTrue(e, list, row) {
      if (!row.subjactId) {
        row.invoiceSubjectRule = "";
        return this.$message.warning('请先选择会计科目！')
      }
      this.$http.post('InvoiceVoucherTemplateController/haveChildOrAuxiliary', { rule: e, subjectId: row.subjactId }).then(res => {
        if (res && res.data.code == 1) {
          //let data = list.find(i=>{return i.value==e});
        } else {
          //let datas = list.find(i=>{return i.value==e});
          row.invoiceSubjectRule = "";
        }
      })
    },
    ///d保存时间到了
    handleBtnSave() {
      this.form.invoiceVoucherAddendumTemList = this.tableData.data.map(i => {
        i.invoiceInfo = i.checkList.toString();
        return i;
      });
      console.log(this.form.invoiceVoucherAddendumTemList);
      this.$http.post('InvoiceVoucherTemplateController/savaTemplate', this.form).then(res => {
        if (res && res.data.code == 1) {
          this.$message.success('保存成功！');
          this.isShow = false;
          this.$emit('successSave', true)
        }
      })
    },
    // 失去焦点
    handleInputBlur(row) {

      let data = row.summaryText ? row.summaryText.split('_') : [];
      if (!data.length || !row.checkList.length) {
        row.summaryText = row.summary;
      } else {
        if (!data[0]) {

          row.summaryText = row.summary + row.summaryText;
        } else {
          data.splice(0, 1);
          if (row.haveSummary) {
            row.summaryText = row.summary + "_" + data.join("_")
          } else {
            row.summaryText = "" + "_" + data.join("_")
          }
        }
      }
      //row.summaryText = row.summary;
    },
    // 摘要选择监听
    handleChangeCheckbox(e, row, list) {
      let data = "";
      list.forEach(i => {
        e.forEach(j => {
          if (i.value === j) {
            data = data ? data + "_" + i.label : i.label;
          }
        })
      })
      if (row.summary && row.haveSummary) {
        row.summaryText = data ? row.summary + "_" + data : row.summary;
      } else {
        row.summaryText = "" + "_" + data;
      }
      // if(e) {
      // 	row.summaryText = row.summaryText? row.summaryText+"_"+i.label:i.label;
      // 	row.invoiceInfo = row.invoiceInfo?row.invoiceInfo+"," +i.value:i.value;
      // }else {
      // 	let data = row.summaryText.split('_');
      // 	let dataId = row.invoiceInfo.split(',');
      // 	摘要显示
      // 	if(data.length===1) {
      // 		row.summaryText = "";
      // 	}else {
      // 		data.forEach((item,index)=>{
      // 			if(item === i.label) {
      // 				data.splice(index,1);
      // 			}
      // 		})
      // 		row.summaryText = data.join("_");
      // 	}
      // 	//摘要明细值
      // 	if(dataId.length===1) {
      // 		row.invoiceInfo = "";
      // 	}else {
      // 		dataId.forEach((item,index)=>{
      // 			if(item === i.value) {
      // 				dataId.splice(index,1);
      // 			}
      // 		})
      // 		row.invoiceInfo = dataId.join(",");
      // 	}
      // }
    },
    //查询摘要列表
    getSummaryList() {
      this.$http.post('sys/dict/list', { type: "InvocieInfo" }).then(res => {
        if (res && res.data.code == 1) {
          this.summaryList = res.data.data.map(i => {
            i.isTrue = false;
            return i;
          })
        }
      })
    },
    // 获取会计科目列表objectOptions
    getObjectOptions() {
      this.$http.post('sys/dict/list', { type: "InvocieInfo" }).then(res => {
        if (res && res.data.code == 1) {
          this.summaryList = res.data.data
        }
      })
    },
    //获取取值
    getInvoiceValue() {
      this.$http.post('sys/dict/list', { type: "invoice_value" }).then(res => {
        if (res && res.data.code == 1) {
          this.invoiceValueList = res.data.data
        }
      })
    },
    //获取科目规则
    getInvoiceSubjectRule() {
      this.$http.post('sys/dict/list', { type: "invoice_subject_rule" }).then(res => {
        if (res && res.data.code == 1) {
          this.invoiceSubjectRuleList = res.data.data.map(i => {
            i.disabled = false;
            return i;
          })
        }
      })
    },
    //获取科目
    getSubject(callback) {
      this.$http.post('subject/getAllSujectByContent', { content: "" }).then(res => {
        if (res && res.data.code == 1) {
          this.subjectList = res.data.data.map(i => {
            i.name = i.code + " " + i.name;
            return i;
          })
          callback && callback();
        }
      })
    },
    // 获取凭证字
    getVoucerWordlList() {
      const _ = this;
      _.$http.post('voucherWord/getVoucherWordList', {}).then((res) => {
        if (res && res.data.code == '1') {
          _.voucherWordList = res.data.data.list;
          _.form.vocherWordId = res.data.data.list.length ? res.data.data.list[0].id : "";
        }
      }).catch(e => {

      });
    },
  },
  watch: {
    isShow(val) {
      if (val) {
        if (this.nowRow && this.nowRow.id) {
          this.form = Object.assign(this.form, {
            voucherDateRule:this.nowRow.voucherDateRule,
            name: this.nowRow.name,
            vocherWordId: this.nowRow.vocherWordId,
            invoiceVoucherAddendumTemList: [],
            id: this.nowRow.isCopy?'':this.nowRow.id,
          })

          this.nowRow.invoiceVoucherAddendumTemList.forEach((i,index) => {
            i.checkList = i.invoiceInfo ? i.invoiceInfo.split(",") : [];
            i.invoiceSubjectRule = i.invoiceSubjectRule ? i.invoiceSubjectRule.toString() : "";
            i.invoiceValue = i.invoiceValue ? i.invoiceValue.toString() : "";
            i.index = index;
            if(this.nowRow.isCopy){
              i.id = "";
            }

          });
          this.tableData.data = JSON.parse(JSON.stringify(this.nowRow.invoiceVoucherAddendumTemList))
        } else {
          this.tableData.data = [];
          this.form = Object.assign(this.form, {
            name: "",
            invoiceVoucherAddendumTemList: [],
            id: "",
            voucherDateRule:0,
          })
          for (var i = 0; i < 3; i++) {
            this.tableData.data.push(JSON.parse(JSON.stringify(this.tableData_c)))
          }
          this.tableData.data.forEach((j, index) => {
            j.index = index;
          })
        }

      }
    }
  }
}
</script>
<style lang='less'>
#AddInvoiceTemplate {
  .AddInvoiceTemplateDialog {
    .el-dialog__header {
      text-align: center;
      padding: 30px 0;
      color: #333333;
      border-bottom: none;

      .el-dialog__title {
        font-size: 30px;
        font-weight: 500;
      }
    }

    .el-dialog__body {
      padding: 0px 30px 50px 0px;
    }

    .dropdown {
      width: 205px;
      background-color: #eee;
      position: absolute;
    }

    .el-table__row {
      .hiddenRow {
        display: none;
        line-height: 10px;

        span {
          display: block;
          cursor: pointer;
        }
      }

      &:hover {
        .hiddenRow {
          display: block;
        }
      }

      ;
    }

    .cellStyle {
      border-bottom: none;
      background: #fff;
    }

    .headerCellStyles {
      background-color: #fff;
      border-color: #fff !important;
    }

    .el-table--border {
      border: none;
    }

    .el-table::before {
      height: 0;
    }

  }


}
</style>



// WEBPACK FOOTER //
// src/components/dialog/AddInvoiceTemplate.vue